module.exports = __webpack_public_path__ + "static/media/undraw-feeling-blue-4-b-7-q-copy.74c19b42.svg";